import { CustomUsers } from '../api';

import { AsyncFunction } from './types';
import { SessionType } from '../data/types';

export const fetchUser: AsyncFunction<string, SessionType> = async (csrftoken: string) => {
  return await CustomUsers.custom.getUserData({ headers: { 'X-CSRFToken': csrftoken } });
};
